import Link from 'next/link'
import React from 'react'
import { ICar, ICarObj, IGalleryImage } from 'shared-interfaces'

import DuoGridMobile from '../grids/imagesGrid/duoGridMobile'
import GarageBannerViewMobile from '../lists/imageLists/garageBannerViewMobile'

interface Props {
    carsData: ICarObj
    activeView: string
    areCarsLoading: boolean
    carsIdList: string[]
    garage_link_id: any

    get_cover_img: (car: ICar) => IGalleryImage | undefined
}

type State = {
    carsDataFinished: null | {}
}

class GarageViewManagerMobile extends React.Component<Props, State> {
    state = {
        carsDataFinished: null,
    }

    componentDidMount() {}

    renderRightView = (activeView: string) => {
        if (activeView === 'banner_view') {
            return this.props.carsIdList.map((id: string, index: number) => {
                let car = this.props.carsData[id]

                if (car) {
                    return (
                        <Link
                            href={`/garage/${this.props.garage_link_id}/car/${id}/overview`}
                            key={index}
                            passHref
                        >
                            <a data-attr="garage_banner_item_desktop">
                                <GarageBannerViewMobile
                                    item={{
                                        car: this.props.carsData[id],
                                        cover_img: this.props.get_cover_img(
                                            this.props.carsData[id]
                                        ),
                                    }}
                                />
                            </a>
                        </Link>
                    )
                }
            })
        } else if (activeView === 'grid_view') {
            return (
                <DuoGridMobile
                    carsIdsList={this.props.carsIdList}
                    carsdata={this.props.carsData}
                    garage_link_id={this.props.garage_link_id}
                    get_cover_img={this.props.get_cover_img}
                />
            )
        }
    }

    render() {
        const { areCarsLoading, activeView } = this.props

        return (
            <React.Fragment>
                {areCarsLoading !== true && this.renderRightView(activeView)}
            </React.Fragment>
        )
    }
}

export default GarageViewManagerMobile
